import React from "react";
import "../../../../../Assets/Styles/SimpleTextInput.scss";

const SimpleTextInput = (props) => {
  const transformPlaceHolder = () => {
    document
      .getElementById(props.Id + "-placeholder")
      .classList.add("focused-state");
    addActiveState();
  };
  const putPlaceHolderBack = () => {
    if (document.getElementById(props.Id).value.length === 0) {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.remove("focused-state");
      removeActiveState();
    } else {
      document.getElementById(props.Id).classList.remove("active");
      document.getElementById(props.Id).classList.add("filled");
    }
    if (
      document.getElementById(props.Id + "-textarea-holder") !== null ||
      undefined
    ) {
      document
        .getElementById(props.Id + "-textarea-holder")
        .classList.remove("wrong");
    }
  };
  const addActiveState = () => {
    document.getElementById(props.Id).classList.add("active");
  };
  const removeActiveState = () => {
    document.getElementById(props.Id).classList.remove("active");
  };
  return (
    <React.Fragment>
      {props.ClassName ? (
        <label
          id={props.Id + "-textarea-holder"}
          className="cx-simple-text-input"
        >
          <p className="placeholder" id={props.Id + "-placeholder"}>
            {props.PlaceHolder}
          </p>
          <textarea
            onFocus={() => transformPlaceHolder()}
            onBlur={() => putPlaceHolderBack()}
            id={props.Id}
            className={"cx-textarea" + " " + props.ClassName}
            onChange={() => props.ChangeEvent()}
          />
          <p className="validation-message">{props.ValidationMessage} </p>
        </label>
      ) : (
        <label
          id={props.Id + "-textarea-holder"}
          className="cx-simple-text-input"
        >
          <p className="placeholder" id={props.Id + "-placeholder"}>
            {props.PlaceHolder}
          </p>
          <textarea
            onFocus={() => transformPlaceHolder()}
            onBlur={() => putPlaceHolderBack()}
            id={props.Id}
            className="cx-textarea"
            onChange={() => props.ChangeEvent()}
          />
          <p className="validation-message">{props.ValidationMessage} </p>
        </label>
      )}
    </React.Fragment>
  );
};
export default SimpleTextInput;
